/*
 * @Author: wangyan1
 * @Description:
 * @Date: 2022-04-25 17:07:00
 * @LastEditTime: 2023-11-08 16:27:12
 * @FilePath: /teacher-xkh-web/src/service/common/index-url.js
 */

// import filters from '@/filters/index'
import { mapGetters, mapMutations } from 'vuex'

export default {
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters({
      baseData: 'common/baseData',
      periodList: 'common/periodList',
      classCycleList: 'common/classCycleList',
      yearList: 'common/yearList',
      gradeList: 'common/gradeList',
      timeIntervalList: 'common/timeIntervalList',
      semesterList: 'common/semesterList',
      linkTypeList: 'common/linkTypeList',
      groupStudentTypeList: 'common/groupStudentTypeList',
      teacherOperateTypeList: 'common/teacherOperateTypeList',
      classCorrectTypeList: 'common/classCorrectTypeList',
      classCorrectOptTypeList: 'common/classCorrectOptTypeList',
      activePeriod: 'common/activePeriod',
      activeClassCycle: 'common/activeClassCycle',
      activeTimeInterval: 'common/activeTimeInterval',
      activeSemester: 'common/activeSemester',
      activeLinkType: 'common/activeLinkType',
      activeGroupStudentType: 'common/activeGroupStudentType',
      activeTeacherOperateType: 'common/activeTeacherOperateType',
      jurisdictionTypeList: 'common/jurisdictionType'
    }),
    // ['全部', 2022, 2023...]
    yearData() {
      const years = (this.yearList || []).map(item => item.name)
      return years
    },
    // ['全部', '春', '夏', '秋, '冬']
    semesterData() {
      const semesters = (this.semesterList || []).map(item => item.name)
      return semesters
    }
  },
  created() {
    // this.getSelectionsByType()
  },
  methods: {
    ...mapMutations({
      setBaseData: 'common/setBaseData'
    }),
    getSelectionsByType() {
      if (!this.semesterList || (this.semesterList && this.semesterList.length === 0)) {
        // TODO: 基础数据重复调用问题待解决
        this.getBaseData()
      }
    },
    async getBaseData() {
      const baseData = await this.$service.common.getBaseData()
      if (baseData) {
        this.setBaseData(baseData)
        this.$store.commit('common/setPeriodList', baseData.period)
        this.$store.commit('common/setClassCycleList', baseData.classCycle)
        this.$store.commit('common/setYearList', baseData.year)
        this.$store.commit('common/setTimeIntervalList', baseData.timeInterval)
        this.$store.commit('common/setSemesterList', baseData.semester)
        this.$store.commit('common/setLinkTypeList', baseData.linkType)
        this.$store.commit('common/setGroupStudentTypeList', baseData.groupStudentType)
        this.$store.commit('common/setTeacherOperateTypeList', baseData.teacherOperateType)
        this.$store.commit('common/setClassCorrectTypeList', baseData.classCorrectType)
        this.$store.commit('common/setClassCorrectOptTypeList', baseData.classCorrectOptType)
      }
    }
  },
  mounted() {
  }
}
